import { forwardRef } from 'react'

import LoaderGradient from '../../icons/LoaderGradient'
import { cn } from '../../utils/cn'

const Spinner = forwardRef<SVGSVGElement, React.ComponentProps<'svg'>>(
  ({ className, ...props }, ref) => {
    return (
      <LoaderGradient
        ref={ref}
        role="status"
        aria-label="Loading"
        className={cn('text-foreground size-5', className)}
        {...props}
      />
    )
  }
)

Spinner.displayName = 'Spinner'

export { Spinner }
